import type { IPlan } from '~/modules/pricing/types';

import { usePricingStore } from '~/modules/pricing';
import { IPlanKey } from '~/modules/pricing/types';
import { CONFIG_PRICING } from '../configs';

export interface IPricingPlanActive {
  isLoading: boolean;
  activePlan?: IPlan;
  activePlanKey: IPlanKey;
  activePlanName: string;
}

export const usePricingPlanActive = (): IPricingPlanActive => {
  const shopPlatformPlanActive = usePricingStore((state) => state.shopPlatformPlanActive);
  // const isFetchedShopPlatformPlans = usePricingStore((state) => state.isFetchedShopPlatformPlans);
  const isFetchedSubscriptionTrialUsage = usePricingStore(
    (state) => state.isFetchedSubscriptionTrialUsage,
  );
  const isFetchedShopPlatformPlanActive = usePricingStore(
    (state) => state.isFetchedShopPlatformPlanActive,
  );

  const activePlan = shopPlatformPlanActive?.plan;
  const activePlanKey = getPaidPlanKey(activePlan);
  const activePlanName = activePlan?.displayName || '';

  return {
    activePlan,
    activePlanKey,
    activePlanName,
    isLoading: !isFetchedShopPlatformPlanActive || !isFetchedSubscriptionTrialUsage,
  };

  function getPaidPlanKey(currentPlan?: IPlan) {
    const activePlanKey = currentPlan?.planKey || CONFIG_PRICING.DEFAULT_PLAN_KEY;
    if (activePlanKey === IPlanKey.CONTENT_TESTING) return IPlanKey.PAGE_OPT;

    return activePlanKey;
  }
};
